<template>
  <v-dialog :value="value" max-width="480px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text class="pb-2">
        <div class="body-2 mb-3">{{ description }}</div>
        <div class="bm-facts">
          <span class="bm-tiny">Perkiraan waktu</span>
          <span>{{ duration }} · halaman tetap bisa dipakai</span>
          <span class="bm-tiny">Email</span>
          <span>Dikirim hanya untuk PO yang berpindah band</span>
          <span v-if="scope === 'all'" class="bm-tiny">Otomatis</span>
          <span v-if="scope === 'all'"
            >Berjalan tiap jam; hitung manual tidak mengubah jadwalnya</span
          >
        </div>
      </v-card-text>
      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Batal</v-btn>
        <v-btn color="primary" :loading="loading" @click="$emit('confirm')">Hitung sekarang</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/** Confirmation before a recompute: what happens, how long, and what gets e-mailed. */
export default {
  name: "budget-recompute-dialog",
  props: {
    value: Boolean,
    loading: Boolean,
    /** all | po | job */
    scope: { type: String, default: "all" },
    /** "819 PO · 254 job" / "PO 4100003000" / "job 1146998" */
    subject: { type: String, default: "" },
    lastRunAt: { type: String, default: "" },
  },
  computed: {
    title() {
      return this.scope === "all"
        ? "Hitung ulang semua PO?"
        : this.scope === "po"
        ? "Hitung ulang PO ini?"
        : "Hitung ulang job ini?";
    },
    description() {
      const what = this.subject || (this.scope === "all" ? "semua PO dan job" : "PO / job ini");
      const replace = this.lastRunAt ? `, lalu mengganti perhitungan ${this.lastRunAt}` : "";
      return `Mengambil data terbaru PO supplier, MR, dan kurs untuk ${what}${replace}.`;
    },
    duration() {
      return this.scope === "all" ? "± 30 detik" : "beberapa detik";
    },
  },
};
</script>

<style scoped>
.bm-facts {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 12px;
  font-size: 13px;
}
</style>
